import { numberToDisplayString } from 'further-ui/utils';
import { styled } from '@mui/material';

const InputTypography = styled('span')(({ theme }) => ({
  display: 'block',
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.body1.fontWeight,
  lineHeight: theme.typography.body1.lineHeight,
  padding: theme.spacing(1, 2),
}));

const UnitsSoldCell: React.FC<{ value: number }> = ({ value }) => (
  <InputTypography>{numberToDisplayString(value)}</InputTypography>
);

export default UnitsSoldCell;
